interface ArrowRightIconProps {
	iconColor?: string;
	width?: string;
	height?: string;
}
const SearchIcon = ({ iconColor = '#212529', width = '21', height = '20' }: ArrowRightIconProps) => (
	<svg width={width} height={height} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<ellipse cx="9.66667" cy="9.16667" rx="6.66667" ry="6.66667" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M14.25 14.1318L18.4167 18.2985" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default SearchIcon;
